import React from 'react';
import Skeleton from '@mui/lab/Skeleton';
import { StyledWrapper } from './styled';

const FlowListSkeleton = () => (
  <StyledWrapper>
    <Skeleton variant="rectangular" height={1000} width="100%" />
  </StyledWrapper>
);

export default FlowListSkeleton;
